import { render, staticRenderFns } from "./ChatAssignBoard.vue?vue&type=template&id=27e17a92&scoped=true"
import script from "./ChatAssignBoard.vue?vue&type=script&lang=js"
export * from "./ChatAssignBoard.vue?vue&type=script&lang=js"
import style0 from "./ChatAssignBoard.vue?vue&type=style&index=0&id=27e17a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e17a92",
  null
  
)

export default component.exports